import React, { useEffect, useState } from "react";
import {ReactComponent as ChevronDown} from '/public/assets/css/ontario-design-system/icons/svg/ontario-icon-chevron-down.svg';
import {ReactComponent as ChevronUp} from '/public/assets/css/ontario-design-system/icons/svg/ontario-icon-chevron-up.svg';
import { RichTextComponent } from "../runtimeComponent/subComponent/RichTextComponent";
import { FormSectionElements, ProgramContainer } from "../entities/formTemplateDataType";
import { getRootComponent } from "../utilities/ElementUtils";

export type AccordionContentType = 'Html' | 'Text' | 'Rich Text'

export type AccordionParagraph = {
    content: string;
    type: AccordionContentType;
};

export type AccordionData = {
    name?: string;
    title: string;
    paragraphs?: AccordionParagraph[],
    expand: boolean;
};

const AccordionsComponent = ({
    field,
    contents, 
    expandAll,
    callBack,
    callbackStepIndex,
    lang='en'
}: {
    field: FormSectionElements;
    contents: AccordionData[];
    expandAll: boolean;
    callBack: (programContrainer: ProgramContainer) => void;
    callbackStepIndex?: (index: number, returnIndex?: number) => void;
    lang: 'en' | 'fr'
}) => {
    const [allExpand, setAllExpand] = useState(expandAll);
    const [items, setItems] = useState([]);

    useEffect(() => {
        let accordions = contents?.filter(content => !!content.title).map(item => ({...item, expand: expandAll? true: item.expand})) ?? [];
        setItems(accordions);
    }, [contents]);

    useEffect(() => {
        const collapsed = items.filter(item => !item.expand);
        setAllExpand(!collapsed.length)
    }, [items]);

    const toggleExpendPragraph = (item: AccordionData, index: number) => {
        const newItems = items.map((item, idx) => {
            if (idx === index) {
                return {...item, expand: !item.expand}
            }
            return item;
        });
        setItems(newItems);
    };

    const toggleExpandAll = () => {
        let newItems = items.map(item => ({...item, expand: !allExpand}));
        setAllExpand(!allExpand);
        setItems(newItems);
    }

    if (!contents?.length) return null;

    return (
        <div className="ontario-margin-top-24-! ontario-margin-bottom-24-!">
            {items.length > 1 && (
                <div className="accordion-header">
                    <button className="accordion-button" onClick={toggleExpandAll}>
                        {allExpand? lang === 'en' ? 'Collapse All' : 'Tout réduire' : lang==='en' ? 'Expand All' : 'Tout développer'}
                    </button>
                </div>
            )}
            <div>
                {items.map((item, index) => (
                    <div className="accordion-panel">
                        <div className="accordion-title">
                            <button className="accordion-title-button"
                                aria-expanded={item.expand || allExpand}
                                aria-controls={`accordion-content-${index}`}
                                onClick={() => toggleExpendPragraph(item, index)}
                            >
                                {(allExpand || item.expand) && (
                                    <ChevronUp aria-hidden="true" focusable="false" role="presentation" className='accordion-expand-img'/>
                                )}
                                {(!allExpand && !item.expand) && (
                                    <ChevronDown aria-hidden="true" focusable="false" role="presentation" className='accordion-expand-img'/>
                                )}
                                {item.title}
                            </button>
                            <div id={`accordion-content-${index}`} hidden></div>
                        </div>
                        {(item.expand || allExpand) && item.paragraphs.map(paragraph => {
                            return (
                                <div className="accordion-content">
                                    {paragraph.type === 'Text' && <p>{paragraph.content}</p>}
                                    {paragraph.type === 'Rich Text' && 
                                        <RichTextComponent field={field} 
                                            editable={false}
                                            value={paragraph.content}
                                            isEng={lang==='en'}
                                            title={item.title}
                                            requiredField={false}
                                            labelControlArray={[]}
                                            callbackStepIndex={(currenPageIndex,returnIndex)=>callbackStepIndex(currenPageIndex,returnIndex)}
                                            callbackElement={(p) => callBack(getRootComponent(p))}
                                        />
                                    }
                                    {paragraph.type==='Html' && (
                                        <div dangerouslySetInnerHTML={{__html: paragraph.content}}/>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default AccordionsComponent;